import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { VentaService } from '../../services/venta.service';
import { TranslateService } from 'src/app/shared/services/translate.service';


interface DialogData {
  appConfig: any;
}

export interface DialogSalePauseResult {
  confirm: boolean;
  tag: string;
}

@Component({
  selector: 'dialog-sale-pause',
  templateUrl: 'dialog-sale-pause.component.html',
  styleUrls: ['./dialog-sale-pause.component.scss'],
})
export class DialogSalePauseComponent {
  tagForm: FormGroup;
  showMsgError: boolean = false;
  mailsValidos: boolean;
  cadenaMails: string;
  showForm = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogSalePauseComponent>,
    private ventaService: VentaService,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    console.log({
      dataReceived: data
    });

    this.showForm = data.appConfig.AppConfigJsonConfig.PausarVentasSolicitarTag
      ? +data.appConfig.AppConfigJsonConfig.PausarVentasSolicitarTag === 1
      : false;

    //El tag solo debe aceptar letras, números, un guión o (/) y un espacio en blanco
    this.tagForm = this.fb.group({
      tag: ['', [Validators.pattern(/^[a-zA-Z0-9\s\/\-]*$/), Validators.maxLength(50)]]
    });

  }

  onNoClick() {
    this.dialogRef.close({
      confirm: false,
      tag: ''
    });
  }

  confirm() {
    this.tagForm.markAsTouched();
    if (this.tagForm.valid) {
      const tagValue = this.tagForm.get('tag').value;
      this.dialogRef.close({
        confirm: true,
        tag: tagValue
      });
    }
  }

  validateFields(field: string) {
		return this.isValidAnyField(field);
	}

	isValidAnyField(field: string) {
		let fc_pv = this.tagForm.controls;
		return fc_pv[field].errors != null || fc_pv[field].invalid ? true : false;
	}

  getErrorMessage(field: string) {
		let fc_pv = this.tagForm.get(field);
		if (fc_pv) {
			if (fc_pv.errors) {
				if (fc_pv.errors.required) {
					return this.translateService.instant("CAMPO_REQUERIDO");
				} else if (field === "tag") {
					if (fc_pv.hasError("pattern")) {
						return this.translateService.instant("ERROR_TAG_INPUT");
					}
				}
			}
		}
		return "Error";
	}

}
